var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('slide'),_c('mensaje-insituto'),_c('programas'),_c('otros-enlaces'),_c('obligaciones-transparencia')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }